import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PiCheckCircleFill, PiCircleFill } from 'react-icons/pi';
import { RELEASE_TYPE } from 'services/music-product-digital/types/enums';
import './ReleaseTypeSelectCard.scss'

interface IReleaseTypeSelectCardProps {
  releaseType: RELEASE_TYPE;
  isSelected?: boolean;
  onClick?: (releaseType: RELEASE_TYPE) => void;
  disabled?: boolean;
}

const ReleaseTypeSelectCard = ({
  releaseType,
  isSelected,
  onClick,
  disabled,
}: IReleaseTypeSelectCardProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames('release-type-select-card', { isSelected, disabled })}
      onClick={() => !disabled && onClick && onClick(releaseType)}
    >
      <div className="release-type-select-card-header">
        <div className="release-type-select-card-header-name">
          {t(`release-type.${RELEASE_TYPE[releaseType]}.name`)}
        </div>
        <div className="release-type-select-card-header-description">
          {t(`release-type.${RELEASE_TYPE[releaseType]}.description`)}
        </div>
      </div>
      {isSelected ? <PiCheckCircleFill /> : <PiCircleFill />}
    </div>
  );
};

export default ReleaseTypeSelectCard;
